import React, { PureComponent } from 'react';
import localeLookup from '../../config/locale';
import CheckList from '../CheckList';
import ModalBody from './ModalBody';
import ModalFilter from './ModalFilter';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import ModalWrapper from './ModalWrapper';
import EmptyState from '../EmptyState';
import Text from '../Text';
import SwitchCheckbox from '../SwitchCheckbox';
import { compareFalsy, compareLocal, searchString, sortBy } from '../../utils/helpers';
import ModalSection from './ModalSection';
import { ACCESS_LEVELS } from '../../constants';

export default class GroupAdministratorModal extends PureComponent {
  constructor(props) {
    super(props);
    const { personAccessLevels } = props;
    this.state = {
      filterString: '',
      selectedOptionIds: props.selectedOptionIds || [],
      overAllGroupAdministrator: [
        ACCESS_LEVELS.champadministrator,
        ACCESS_LEVELS.administrator,
        ACCESS_LEVELS.groupAdministrator,
      ].some((accessLevel) => personAccessLevels.includes(accessLevel)),
    };
  }

  isAllOptionsSelected = () => {
    const { selectedOptionIds } = this.state;
    const { renderSectioned, options } = this.props;
    if (renderSectioned) {
      return options.every((group) =>
        group.options.every((option) => selectedOptionIds.includes(option.id))
      );
    } else {
      return options.every((option) => selectedOptionIds.includes(option.id));
    }
  };

  getVisibleOptions = (options) => {
    const { selectedOptionIds } = this.props;
    const { filterString } = this.state;

    const filteredOptions = options.filter((option) => {
      if (option.searchString) {
        return searchString(option.searchString, filterString);
      }
      return searchString(option.title, filterString) || searchString(option.subtitle, filterString);
    });

    return sortBy(filteredOptions, [
      (a, b) => compareLocal(a.title, b.title),
      (a, b) =>
        compareFalsy(
          selectedOptionIds.includes(a.id),
          selectedOptionIds.includes(b.id)
        ),
    ]);
  };

  onConfirm = () => {
    const { options, selectedOptionIds, overAllGroupAdministrator } =
      this.state;
    const { onConfirm } = this.props;
    onConfirm({ selectedOptionIds, options, overAllGroupAdministrator });
  };

  onFilterChange = (e) => {
    this.setState({
      filterString: e.target.value,
    });
  };

  onToggleOption = (id) => {
    const { selectedOptionIds } = this.state;
    this.setState({
      selectedOptionIds: selectedOptionIds.includes(id)
        ? selectedOptionIds.filter((selectedId) => selectedId !== id)
        : [...selectedOptionIds, id],
    });
  };

  onToggleOverallGroupAdministrator = () => {
    const { overAllGroupAdministrator } = this.state;
    this.setState({ overAllGroupAdministrator: !overAllGroupAdministrator });
  };

  render() {
    const {
      title,
      onClose,
      confirmBtnText,
      onFilterButtonClick,
      filterPlaceholder,
      filterButtonText,
      showFilterButton,
      options,
      emptyStateText,
      subtitle,
      showToggleAll,
      personAccessLevels,
    } = this.props;
    const {
      filterString,
      selectedOptionIds,
      overAllGroupAdministrator,
    } = this.state;
    const showEmptyState = options.length === 0;
    const overAllGroupAdministratorDisabled = [
      ACCESS_LEVELS.champadministrator,
      ACCESS_LEVELS.administrator,
    ].some((accessLevel) => personAccessLevels.includes(accessLevel));
    return (
      <ModalWrapper>
        <ModalHeader
          title={localeLookup('translations.Group administrator')}
          onClose={onClose}
          subtitle={subtitle}
        />
        <ModalSection>
          <SwitchCheckbox
            onChange={this.onToggleOverallGroupAdministrator}
            isChecked={overAllGroupAdministrator}
            disabled={overAllGroupAdministratorDisabled}
            tooltip={
              overAllGroupAdministratorDisabled
                ? localeLookup(
                    'translations.Can not change because person is administrator'
                  )
                : null
            }
            name="overAllGroupAdministrator"
            wrapperClassName="mediator-approval-options__option"
            labelText={localeLookup(
              'translations.Group administrator in all groups'
            )}
          />
        </ModalSection>
        <ModalFilter
          placeholder={
            filterPlaceholder || `${localeLookup('translations.Search')}...`
          }
          onChange={this.onFilterChange}
          value={filterString}
          buttonIcon="plus-circle"
          buttonText={filterButtonText}
          onButtonClick={() => onFilterButtonClick({ filterString })}
          showButton={showFilterButton}
        />
        <ModalBody deep>
          {showEmptyState ? (
            <EmptyState body={emptyStateText} />
          ) : (
            <CheckList
              disableAll={overAllGroupAdministrator}
              selectedOptionIds={
                overAllGroupAdministrator
                  ? options.map((option) => option.id)
                  : selectedOptionIds
              }
              options={this.getVisibleOptions(options)}
              onChange={this.onToggleOption}
            />
          )}
        </ModalBody>
        <ModalFooter
          onCancelClick={onClose}
          onConfirmClick={this.onConfirm}
          confirmButtonText={confirmBtnText}
        />
      </ModalWrapper>
    );
  }
}
